import GenaralImg from "../../assets/pages/home/hero/licence.jpg";
import { HeroImage } from "../../components/Image/Image.styled";
import { useTranslation } from "react-i18next";
import { ContactAsSection } from "../../components/ContactAsSection/ContactAsSection";
import LicencesSection from "../../components/LicencesSection/LicencesSection";

const i18nKey = "pages.licence";

const LicencePage = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeroImage
        src={GenaralImg}
        alt={t(`${i18nKey}.title`)}
        $position={"center 40%"}
      />
      <LicencesSection />
      <ContactAsSection />
    </>
  );
};

export default LicencePage;
